import React, { useEffect, useState, useRef } from 'react';

/**
 * AnimatedText — types out the given text word-by-word for a streaming feel.
 * Once a message has been animated once (first render), it's marked done so
 * scrolling away and back doesn't replay the animation.
 */
const AnimatedText = ({ text = '', speedMs = 18, alreadyAnimated = false, onDone }) => {
  const [shown, setShown] = useState(alreadyAnimated ? text : '');
  const indexRef = useRef(0);
  const timerRef = useRef(null);

  useEffect(() => {
    if (alreadyAnimated || !text) {
      setShown(text);
      return undefined;
    }
    setShown('');
    indexRef.current = 0;
    const tick = () => {
      const next = indexRef.current + 1;
      // Step by 1 char to render naturally; longer messages still feel snappy.
      if (next >= text.length) {
        setShown(text);
        if (onDone) onDone();
        return;
      }
      indexRef.current = next;
      setShown(text.slice(0, next + 1));
      timerRef.current = window.setTimeout(tick, speedMs);
    };
    timerRef.current = window.setTimeout(tick, speedMs);
    return () => {
      if (timerRef.current) window.clearTimeout(timerRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text, alreadyAnimated]);

  return (
    <span>
      {shown}
      {!alreadyAnimated && shown.length < text.length && (
        <span className="inline-block w-1.5 h-3.5 -mb-0.5 bg-primary/70 ml-0.5 animate-pulse" />
      )}
    </span>
  );
};

export default AnimatedText;
